import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [empresas, setEmpresas] = useState([]);
  const [activeEmpresa, setActiveEmpresa] = useState(
    localStorage.getItem("bv_empresa") || ""
  );

  useEffect(() => {
    const token = localStorage.getItem("bv_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("bv_token");
      })
      .finally(() => setLoading(false));
  }, []);

  // Multi-empresa: carrega as empresas visíveis e valida a empresa ativa
  useEffect(() => {
    if (!user) return;
    api
      .get("/empresas")
      .then((r) => {
        const list = (r.data || []).filter((e) => e.active !== false);
        setEmpresas(list);
        const stored = localStorage.getItem("bv_empresa") || "";
        const valid =
          stored === "all"
            ? !!user.is_super_admin
            : list.some((e) => e.id === stored);
        if (!valid) {
          const def = list.find((e) => e.is_default) || list[0];
          const next = def ? def.id : "";
          if (next) localStorage.setItem("bv_empresa", next);
          else localStorage.removeItem("bv_empresa");
          setActiveEmpresa(next);
        } else {
          setActiveEmpresa(stored);
        }
      })
      .catch(() => {});
  }, [user]);

  async function login(email, password) {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("bv_token", r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  }

  function logout() {
    localStorage.removeItem("bv_token");
    setUser(null);
    window.location.href = "/login";
  }

  function setEmpresa(id) {
    localStorage.setItem("bv_empresa", id);
    // Recarrega para que TODAS as páginas refaçam as consultas no novo escopo
    window.location.reload();
  }

  const value = useMemo(() => ({
    user, loading, login, logout, setUser,
    empresas, activeEmpresa, setEmpresa,
    isAllMode: activeEmpresa === "all",
    can: (perm) => {
      if (!user) return false;
      if (user.role === "admin") return true;
      const perms = user.effective_permissions || [];
      return perms.includes(perm);
    },
  }), [user, loading, empresas, activeEmpresa]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
